<template>
  <div class="app-container circle-new-edit">
    <basic-container v-loading="loading">
      <div class="operation">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
      </div>
      <el-row class="one-line">
        <el-col :span="2">
          <div>封面：</div>
        </el-col>
        <el-col :span="12">
          <div>
            <div class="image">
              <img ref="originCover" :src="coverImg | ossImageProcess" v-show="showCover" class="origin-cover" />
            </div>
            <div class="upload-btn">
              <el-button @click="handleImageChange" size="small" type="primary">{{this.coverImg ? '重新上传' : '点击上传'}}</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="one-line">
        <el-col :span="2">
          <div>名称：</div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-input v-model.trim="name" :maxlength="10"></el-input>
          </div>
        </el-col>
        <el-col :span="2">
          <span class="limit">
            {{name ? name.length: 0}}/10
          </span>
        </el-col>
      </el-row>
      <el-row class="one-line">
        <el-col :span="2">
          <div>描述：</div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-input type="textarea" v-model.trim="description" :maxlength="50" :rows="5"></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row class="one-line">
        <el-col :span="13"></el-col>
        <el-col :span="2">
          <span class="limit">
            {{description ? description.length: 0}}/50
          </span>
        </el-col>
      </el-row>
      <el-row  class="one-line">
        <el-col :span="2">
          圈子类型：
        </el-col>
        <el-col :span="12">
          <el-radio-group v-model="isPublic" @change="onChangePublic">
            <el-radio label="true">公有圈</el-radio>
            <el-radio label="false">私有圈</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row class="one-line" v-if="isPublic !== 'true'">
        <el-col :span="2">
        </el-col>
        <el-col :span="5">
          <el-button size="small" type="primary" @click="onClickAddPermission">添加分组</el-button>
        </el-col>
      </el-row>
      <el-row v-if="isPublic !== 'true'">
        <el-col :span="2"></el-col>
        <el-col :span="12">
          <div class="permission" v-for="(permission, permissionIndex) in permissions" :key="permissionIndex">
            <el-row>
              <div class="condition" v-for="(condition, conditionIndex) in permission.conditions" :key="conditionIndex">
                <el-col :span="6">
                  <el-select v-model="condition.tagType" placeholder="筛选类型">
                    <el-option
                      v-for="(item, index) in tagTypes"
                      :key="index"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="2">
                  <i v-show="condition.tagType" class="icon el-icon-info" @click="getAllModalContent(condition.tagType)"></i>
                </el-col>
                <el-col :span="5">
                  <el-select v-model="condition.filterType" placeholder="筛选条件">
                    <el-option
                      v-for="(item, index) in filterTypes"
                      :key="index"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="2"></el-col>
                <el-col :span="5">
                  <el-input v-model="condition.tagName" placeholder="请输入筛选内容"></el-input>
                </el-col>
                <el-col :span="2">
                  <el-col :span="3"></el-col>
                  <el-button size="medium"
                          type="text"
                          icon="icon-delete"
                          @click="onClickRemoveCondition(permissionIndex, conditionIndex)">
                  </el-button>
                </el-col>
                 <el-col :span="2">
                  <el-col :span="3"></el-col>
                  <el-button v-show="condition.tagType && condition.filterType && condition.tagName"
                    class="filter-modal-btn"
                    size="small"
                    type="primary"
                    @click="getFilterModalContent(condition)">
                    查看所有符合条件的值
                  </el-button>
                </el-col>
              </div>
            </el-row>
            <el-row v-if="!!permissions[permissionIndex].conditions[0]">
              <div class="condition">
                <el-col :span="16"></el-col>
                <el-col :span="2">
                  <el-button size="small" type="primary" @click="onClickRemovePermission(permissionIndex)">删除分组</el-button>
                </el-col>
                <el-col :span="2"></el-col>
                <el-col :span="2">
                  <el-button size="small" type="primary" @click="onClickAddCondition(permissionIndex)">添加条件</el-button>
                </el-col>
              </div>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </basic-container>
    <el-dialog
      width="600px"
      top="103px"
      :title="dialogTitle"
      :visible.sync="showDialog"
      :show-close="true"
      :close-on-click-modal="false"
      @closed="showDialog=false">
      <div v-if="!filterContent.length">暂无数据</div>
      <div class="dialog-content">
        <div class="dialog-item" v-for="(item, index) in filterContent" :key="index">{{item}}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getFileKeyAsync } from '@/util/util'
import { getOSSCircle } from '@/api/basic/aliyunoss'
import { addObj, getTagsByType } from '@/api/post/circle'
import uploadService from '@/common/common-logic/upload-service'
import { filterTypesEnum, tagTypesEnum, filterTypesValueEnum } from '@/const/circleFilterType';

export default {
  data () {
    return {
      loading: false,
      id: '',
      coverImg: '',
      name: '',
      description: '',
      industries: [],
      location: '',
      company: '',
      showCover: false,
      originCover: '',
      isPublic: 'true',
      tagTypes: tagTypesEnum,
      tagType: '',
      filterTypes: filterTypesEnum,
      filterTypesValue: filterTypesValueEnum,
      filterType: '',
      tagName:'',
      permissions: [{
        conditions: [{}],
      }],
      circlePermission: [],
      showDialog: false,
      filterContent: [],
      dialogTitle: '查看所有符合条件的值',
    }
  },
  methods: {
    onChangePublic() {
      if (this.isPublic === 'true') {
        this.permissions = [{
          conditions: [{}],
        }];
      }
    },
    onClickRemoveCondition(permissionIndex, conditionIndex) {
      this.permissions[permissionIndex].conditions.splice(conditionIndex, 1);
    },
    onClickRemovePermission(permissionIndex) {
      this.permissions.splice(permissionIndex, 1);
    },
    onClickAddCondition(permissionIndex) {
      this.permissions[permissionIndex].conditions.push({});
    },
    onClickAddPermission() {
      this.permissions.push({
        conditions: [{}],
      });
    },
    handleExceed () {
      this.$message({
        message: '只能选择一张图片',
        type: 'error'
      })
    },
    handleImageRemove () {
      this.coverImg = null
      if (this.originCover) {
        this.showCover = true
        this.$refs['originCover'].src = this.originCover
      }
    },
    async handleImageChange (file, fileList) {
      this.$openMaterialLib((list) => {
        if (!list || list.length === 0) {
          return;
        }
        this.coverImg = list[0].contentUrl
        this.showCover = true
      }, 1);
    },
    validate () {
      if (!this.coverImg) {
        this.$message({
          message: '圈子封面不能为空',
          type: 'error'
        })
        return false
      }
      if (!this.name) {
        this.$message({
          message: '圈子名称不能为空',
          type: 'error'
        })
        return false
      }
      if (!this.description) {
        this.$message({
          message: '圈子描述不能为空',
          type: 'error'
        })
        return false
      }
      if (this.isPublic === 'false') {
        let isSuccess = this.circlePermission !== null && this.circlePermission.length > 0;
        if (isSuccess) {
          this.circlePermission.map(item => {
            if (! (item.groupIndex > -1 && !!item.tagName && !!item.filterType && !!item.tagType)) {
              isSuccess = false;
            }
          });
        }
        if (!isSuccess) {
            this.$message({
            message: '权限控制不能为空',
            type: 'error'
          })
          return false
        }
      }
      return true
    },
    getParams () {
      const isPublic = this.isPublic === 'true';
      if (!isPublic) {
        this.circlePermission = this.formatPermissions(this.permissions)
      }

      return {
        id: this.id,
        circleName: this.name,
        circleType: 0,
        description: this.description,
        coverImg: this.coverImg,
        company: this.company,
        location: this.location,
        industries: this.industries,
        isPublic,
        permissions: this.circlePermission,
      }
    },
    formatPermissions(permissions) {
      let result = [];

      permissions.forEach((permission, groupIndex) => {
        permission.conditions.forEach(con => {
          result.push({...con, groupIndex});
        });
      });

      return result;
    },
    cancel () {
      this.$router.$avueRouter.closeTag()
      this.$router.go(-1)
    },
    submit () {
      const params = this.getParams();
      if (!this.validate()) {
        return false
      }
      addObj(params).then(response => {
        if (response.data.code === 0) {
          this.$message({
            message: '创建成功',
            type: 'success'
          })
          this.$router.$avueRouter.closeTag()
          this.$router.push({
            path: `/post/circle/detail/${response.data.data}`,
          })
        } else {
          this.$message({
            message: response.data.msg,
            type: 'error'
          })
        }
      })
    },
    async getAllModalContent(type) {
      this.dialogTitle = '查看所有值';
      if (type) {
        const response = await getTagsByType(type);
        this.filterContent = response.data.data;
      }
      this.showDialog = true;
    },
    async getFilterModalContent(condition) {
      this.dialogTitle = '查看所有符合条件的值';
      let allContent;
      if (condition.tagType) {
        const response = await getTagsByType(condition.tagType);
        allContent = response.data.data;
      }
      if (!allContent.length) return;
      this.showDialog = true;
      const tagName = condition.tagName.trim().toLowerCase();
      switch(condition.filterType) {
        case this.filterTypesValue.EQUAL:
          this.filterContent = allContent.filter((v) => v.toLowerCase() === tagName);
          return;
        case this.filterTypesValue.NOT_EQUAL:
          this.filterContent = allContent.filter((v) => v.toLowerCase() !== tagName);
          return;
        case this.filterTypesValue.INCLUDE:
          this.filterContent = allContent.filter((v) => v.toLowerCase().indexOf(tagName) !== -1 );
          return;
        case this.filterTypesValue.NOT_INCLUDE:
          this.filterContent = allContent.filter((v) => v.toLowerCase().indexOf(tagName) === -1);
          return;
        default:
          return;
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.circle-new-edit {
  .one-line {
    font-size: 14px;
    margin: 10px 0;
    display: flex;
    align-items: center;
  }
  .limit {
    font-size: 14px;
    color: #AFAFAF;
    margin-left: 12px;
  }

  .upload-btn {
    display: flex;
    width: 148px;
    height: 148px;
    border: 3px #E4E7ED dashed;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    justify-content: center;
    align-content: center;
  }

  .origin-cover {
    width: 148px;
    height: 148px;
    float: left;
    margin-right: 8px;
  }
  .operation {
    text-align: right
  }

  .permission {
    display: flex;
    flex-direction: column;

    .condition {
      width: 800px;
      display: flex;
    }
  }
  .icon {
    color: #66b1ff;
    margin: 5px 0 0 5px;
  }
  .filter-modal-btn {
    margin-top: -5px;
  }
  .dialog-content {
    max-height: 400px;
    overflow-y: auto;
  }
  .dialog-item {
    margin-bottom: 10px;
  }
}
</style>
